import React from 'react';
import Icon from '../../../components/AppIcon';

const OperationTemplateCard = ({ template, isSelected, onSelect }) => {
  return (
    <div
      onClick={() => onSelect(template)}
      className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 hover:shadow-md ${
        isSelected
          ? 'border-[var(--color-primary)] bg-[var(--color-primary)]/5'
          : 'border-[var(--color-border)] bg-[var(--color-card)] hover:border-[var(--color-primary)]/50'
      }`}
    >
      <div className="flex items-start gap-3">
        <div
          className={`p-2 rounded-lg ${
            isSelected
              ? 'bg-[var(--color-primary)] text-white'
              : 'bg-[var(--color-muted)] text-[var(--color-foreground)]'
          }`}
        >
          <Icon name={template?.icon} size={20} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="font-semibold text-sm text-[var(--color-foreground)] mb-1">
            {template?.name}
          </h4>
          <p className="text-xs text-[var(--color-muted-foreground)] line-clamp-2">
            {template?.description}
          </p>
          <div className="flex items-center gap-2 mt-2">
            <span className="text-xs px-2 py-0.5 rounded-full bg-[var(--color-muted)] text-[var(--color-muted-foreground)]">
              {template?.category}
            </span>
            {template?.requiresApproval && (
              <span className="text-xs px-2 py-0.5 rounded-full bg-[var(--color-warning)]/10 text-[var(--color-warning)]">
                Genehmigung erforderlich
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperationTemplateCard;